import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
const GuestRoute = lazy(() => import('./GuestRoute'));


const AppRoute = () => {

    return (
        <>
            <Suspense fallback={<LoaderText />}>
                <Routes>
                    <Route path='*' element={<GuestRoute />}></Route>
                </Routes>
            </Suspense>
        </>
    )
}

export default AppRoute;